<template>
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13">
  <path d="m6819.094 11562-5.048 4.625zm-10.1 0 5.048 4.625z" transform="translate(-6804.896 -11557.813)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px" fill="none"/>
  <path d="M0 0h18v13H0z" fill="none"/>
</svg>
</template>
